import {
  CollaboratorCmSheet,
  CollaboratorDetails,
} from "../types/api/collaborators.type";
import { roleHasPermission } from "./roleAuth.utils";
import { PermissionsEnum } from "../constants/AppConstants";
import { AuthProfile } from "../types/api/auth.type";

export const canEditCollaboratorHistory = (
  profile: AuthProfile,
  collaborator: CollaboratorDetails,
  currentCmSheet?: CollaboratorCmSheet,
  isMyProfile?: boolean,
  restrictEdit?: boolean,
) => {
  if (isMyProfile) {
    return true;
  }
  if (currentCmSheet?.careerManagerId === profile.id && !restrictEdit) {
    return true;
  }
  if (
    roleHasPermission(profile, PermissionsEnum.EDIT_COLLABORATOR_HISTORY) &&
    collaborator?.terminationDate === null
  ) {
    return true;
  }

  return false;
};
